<template>
  <div class="database-table a-card">
    <virtual-scroll-wrapper
      :headers="headers"
      :list="rows"
      emptyMessage="No Program Pages Found"
      :count="count"
      :colspan="colspan"
      :loading="loading"
      :height="height"
      :selectOnly="selectOnly"
    >
      <template v-slot:default="{ item }">
        <tr
          class="database-row color-alt canclick"
          :class="{ 'primary--text grey lighten-2': item.id === selected.id }"
          style="display: flex"
          @click="onclick(item)"
        >
          <div v-if="selectOnly" v-col-adjwidth="0" style="display: inline-flex; align-items: center">
            <input type="checkbox" :checked="item.id === selected.id" />
          </div>
          <td class="caption" v-col-adjwidth="'Internal title'" style="display: inline-flex; align-items: center">
            <a-truncate :text="formatInternalTitle(item)" />
          </td>
          <td class="caption" v-col-adjwidth="'Type'" style="display: inline-flex; align-items: center">
            <a-truncate :text="formatType(item.type)" />
          </td>
          <td class="caption" v-col-adjwidth="'Updated'" style="display: inline-flex; align-items: center">
            <a-truncate :text="formatDate(item.updated_at)" />
          </td>
        </tr>
      </template>
    </virtual-scroll-wrapper>
  </div>
</template>

<script>
import { pageTypeLabel, pageInternalLabel } from "@/modules/program_pages";

export default {
  props: {
    query: Object,
    selectOnly: Boolean,
    height: String,
  },
  data() {
    return {
      headers: [
        { text: "Internal title", value: "internal_title" },
        { text: "Type", value: "type" },
        { text: "Updated", value: "updated_at" },
      ],
      selected: {},
      rows: [],
      loading: true,
      page: 0,
      queryActive: false,
      count: 0,
    };
  },
  watch: {
    query() {
      this.launchQueryLoop();
    },
  },
  computed: {
    colspan() {
      return this.selectOnly ? 4 : 3;
    },
  },
  methods: {
    formatInternalTitle(item) {
      return pageInternalLabel(item);
    },
    formatType(type) {
      return pageTypeLabel(type);
    },
    formatDate(value) {
      if (!value) return "";
      try {
        return new Date(value).toLocaleString();
      } catch (e) {
        return String(value);
      }
    },
    onclick(item) {
      if (this.selectOnly) {
        this.selected = item;
        this.$emit("select", this.selected);
        return;
      }
      this.goToPage(item);
    },
    goToPage(item) {
      this.$router.push({
        name: "program_page_info",
        params: { id: item.id },
      });
    },
    launchQueryLoop() {
      if (this.queryActive) return;

      this.queryActive = true;
      this.rows = [];
      this.page = 0;
      this.selected = {};
      this.loading = true;

      this.getDataCount(this.query);

      this._queryLoop()
        .then(() => {
          this.queryActive = false;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$root.$error(err);
        });
    },
    _queryLoop() {
      return new Promise((resolve, reject) => {
        this._queryDatabase()
          .then((data) => {
            if (!data.rows.length) return resolve();
            this.rows.push(...data.rows);
            if (!data.continue) return resolve();
            this.page += 1;
            return this._queryLoop().then(resolve);
          })
          .catch((err) => reject(err));
      });
    },
    _queryDatabase() {
      return this.$store
        .dispatch("ProgramPageStore/getProgramPageList", {
          query: { ...this.query },
          page: this.page,
        })
        .then((rows) => {
          if (!rows || !rows.length) return { rows: [], continue: false };
          return { rows, continue: rows.length === 50 };
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
    getDataCount(searchQuery) {
      this.$store
        .dispatch("ProgramPageStore/getProgramPageCount", {
          query: searchQuery,
          page: this.page,
        })
        .then((count) => {
          this.count = count;
        })
        .catch((err) => {
          this.$root.$error(err);
        });
    },
  },
  mounted() {
    this.launchQueryLoop();
  },
};
</script>
